import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import ProviderForm from "@components/forms/ProviderForm";

const ProviderAddEdit = () => {
  const params = useParams()
  const { id: providerId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!providerId ? 'Agregar' : 'Editar'} Provedor`}
      backUrl="/user/providers"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "providerForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <ProviderForm
        formId="providerForm"
        id={providerId}
        saveRedirectUrl="/user/providers"
      ></ProviderForm>

    </PageContainer>
  );
}

export default ProviderAddEdit;
